class MultiImageSwiper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const swiperContainer = this.querySelector('.swiper');
    let parent = this.closest(".multi-image-slider")

    if (!swiperContainer) {
      console.error("Swiper container not found inside component.");
      return;
    }

    this.swiper = new Swiper(swiperContainer, {
      loop: false,
      slidesPerView: 1.5,
      spaceBetween: 24,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },

      navigation: {
        nextEl: parent.querySelector('.swiper-button-next'),
        prevEl: parent.querySelector('.swiper-button-prev'),
      },

      breakpoints: {
        749: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 4,
        }
      }
    });
  }
}

// Register custom element
customElements.define('multi-image-swiper', MultiImageSwiper);